import React from 'react';
import PropTypes from 'prop-types';
import MomentUtils from '@date-io/moment';
import moment from 'moment'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';

function DateSelect(props) {
  const {
    format = "MM/DD/YYYY",
    placeholder = "MM/DD/YYYY ex. 01/01/2001",
    variant = "outlined",
    value,
    error,
    helperText,
    onChange,
    fullWidth,
    disableFuture,
    className,
    disablePast,
    minDate,
    maxDate,
    label,
    name
  } = props;
 
  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <KeyboardDatePicker
        name={name}
        disablePast={disablePast}
        disableFuture={disableFuture}
        allowKeyboardControl={true}
        className={className}
        format={format}
        placeholder={placeholder}
        variant={variant}
        value={moment.utc(value).toISOString()}
        minDate={minDate}
        maxDate={maxDate}
        error={error}
        label={label}
        helperText={helperText}
        onChange={onChange}
        fullWidth={fullWidth}
      />
    </MuiPickersUtilsProvider>
  );
}

DateSelect.propTypes = {
  label: PropTypes.string,
  format: PropTypes.string,
  placeholder: PropTypes.string,
  variant: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  onChange: PropTypes.func,
  fullWidth: PropTypes.bool,
  disableFuture: PropTypes.bool,
  disablePast: PropTypes.bool,
  keyboard: PropTypes.bool,
  className: PropTypes.string,
  name: PropTypes.string,
};

export default DateSelect;
